const envConfig = require('./env.config')
const path = require('path')
const apiTimeout = envConfig.api.timeout
const env = process.env
const REGION_NAME = env.REGION_NAME || null
const EUREKA = env.EUREKA || null
const SERVICE_NAME = env.SERVICE_NAME || 'scorenode'
const cpus = require('os').cpus()
const cpuCnt = cpus && cpus.length

module.exports = (function () {

  const config = Object.assign({
    dirs : {
      root: path.resolve(__dirname + '/../'),
      app : '/app',
      views : '/../app/views',
      partials : '/../app/views/partials'
    },
    name: SERVICE_NAME,
    cpuCnt: cpuCnt,
    cpuPct: process.env.NODE_ENV !== 'production' ? 10 : 65,
    useCluster: true,
    httpCollapsing: true,
    adminPort: 1378,
    enablePurging: true,
    LRUcache: {
      maxMemSize: 67108864,
      minPurgeInterval: 5000
    },
    http: {
      attempts: 2,
      timeout: {
        server: apiTimeout,
        client: 10000,
        dns: 2000
      }
    },
    serviceLink: {
      instance: {
        app: SERVICE_NAME,
        vipAddress: SERVICE_NAME
      },
      ec2Region: REGION_NAME,
      eureka: EUREKA
    }
  }, envConfig)

  return config
}())



// WEBPACK FOOTER //
// ../config/index.js